import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import Button from '../../buttons/Button';
import "./Prava.scss";
import withMeta from '../../utils/withMeta';
import flags from '../../utils/flags';
import * as storage from '../../utils/storage';
import { buildUrl } from "../../utils/helper"
import { useDidMount } from '../../utils/hooks';

const UzWizard = ({ akc, db, meta, selected }) => {

  const [currentUserUro, setCurrentUserUro] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  useDidMount(() => {
    getCurrentUserUro();
  })

  const getCurrentUserUro = async () => {
    const user = storage.getUser();
    const res = await meta.get("IUz", user.I_UZ, db);
    setCurrentUserUro(res?.Data?.Uro?.IUro);
  }

  const handleOpen = () => {
    navigate("/uz-wizard", { state: { from: location, uz: selected[0], db: db } })
  }

  const disabled = (Boolean(flags.ADD & akc.hidden) && selected.length === 0) ||
    (selected.length > 1 || currentUserUro > selected[0]?.Uro?.IUro || selected[0]?.Zrus);
  return (
    <>
      <Button
        onClick={handleOpen}
        title={selected.length === 0 ? "Vytvorenie používateľa" : "Aktualizácia používateľa"}
        imageUrl={buildUrl(selected.length === 0 ? 'assets/icons/toolbar_add-person.svg' : 'assets/icons/toolbar_hromadna_uprava.svg')}
        disabled={disabled}
      />
    </>
  );
}


UzWizard.propTypes = {
  selected: PropTypes.array.isRequired,
  db: PropTypes.string,
  akc: PropTypes.object.isRequired,
}

export default withMeta(UzWizard);